import React, {useState} from "react";
import {FieldProps} from "react-jsonschema-form";
import SuggestionInput from "./SuggestionInput";
import BooleanRadioWidget from "./BooleanRadioWidget";
import styled from "styled-components";
import {FontBase} from "../../../styles/fonts";


type FormData = {
  checked: boolean;
  explanation?: string | null;
}

interface PepProps extends FieldProps {
  formData: FormData;
  schema: any;
  onChange: (d: FormData) => void;
  rawErrors?: Array<string>;
}

function handleRadioClick(checked: boolean, onChange: (d: FormData) => void, explanation?: string | null) {
  if (!checked) {
    return onChange({checked});
  }
  onChange({checked, explanation: explanation || null});
}

function handleSuggestionInputChange(
  value: string,
  onChange: (d: FormData) => void,
  formData: FormData,
  setExplanation: any
) {
  const newExplanation = formData.checked ? value : "";
  onChange({checked: formData.checked, explanation: newExplanation || null});
  setExplanation(newExplanation);
}

function Pep(props: PepProps) {
  const formData = props.formData || {checked: null, explanation: ""}
  const [explanation, setExplanation] = useState(formData.explanation);
  const errors = props.rawErrors || [];
  const errorNames = Object.keys(props.errorSchema || {});

  const checked = formData.checked
  return (
    <>
      <QuestionFrame>
        <Title error={errors.length > 0}>
          {props.schema.properties.checked.description}
        </Title>
        <BooleanRadioWidget value={checked} onChange={(checked) => {
          handleRadioClick(
            checked,
            props.onChange,
            explanation
          )
        }}
        />
      </QuestionFrame>
      {checked ? (
        <QuestionFrame>
          <Title error={errorNames.includes("explanation")}>
            {props.schema.properties.explanation.description}
          </Title>
          <SuggestionInput {...props} value={explanation} onChange={(value) => {
            handleSuggestionInputChange(
              value,
              props.onChange,
              props.formData,
              setExplanation
            )
          }}/>
        </QuestionFrame>
      ) : null}
    </>
  );
}

const QuestionFrame = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 10px;
`;

const Title = styled(FontBase)<{ error: boolean }>`
    font-weight: 700;
    font-size: 16px;
    color: ${(props) => {
        return props.error ? "#ff0000" : "inherit";
    }};

    @media (max-width: 700px), (max-height: 700px) {
        font-size: 14px;
    }
`;

export default Pep;
